module.exports = __webpack_public_path__ + "static/media/1-18.dc3df401.mp3";